<div class="table-responsive" *ngIf="teklifler">
  <table class="table card-table table-vcenter text-nowrap datatable">
    <thead>
    <tr>
      <th class="w-1">Talep No</th>
      <th>Teklif Tarihi</th>
      <!-- <th>Talep Id</th> -->
      <th>Şube Adı</th>
      <th>Talep Türü</th>
      <th>Ürün Grubu</th>
      <th>Teklif Durumu</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let t of teklifler">
      <td><span class="text-muted">{{t.talep?.talepNo}}</span></td>
      <td>{{t.olusturmaTarihiText}}</td>
      <!-- <td>{{t.talepId}}</td> -->
      <td>{{t.talep?.sube?.isim}}</td>
      <td>{{t.talep?.talepTur?.isim}}</td>
      <td>{{t.talep?.urunGrup?.isim}}</td>
      <td>{{t.durumText}}</td>
      <td class="text-right">
        <div *ngIf="t.durum === DURUM_INITIAL" class="btn btn-sm btn-primary mr-3"
             (click)="incele(t,ACTION_TEKLIF_GIR)">Teklif Gir
        </div>
        <div *ngIf="t.durum === DURUM_CEVAPLANDI" class="btn btn-sm btn-primary mr-3"
             (click)="incele(t,ACTION_TEKLIF_REVIZE)">Revize Et
        </div>
        <div class="btn btn-sm btn-success" (click)="incele(t)">İncele</div>
      </td>
    </tr>
    </tbody>
  </table>
</div>
